import { FieldTests, LocalStorage, StorageManagerFactory, StorageVersionManager, } from "restaumatic-client";
import { menuStickyTabs } from "./experiments/MenuStickyTabs";
/**
 * This divides sites into groups that can be used in experiments.
 * Good practices:
 * - assign only one experiment to the group
 * - groups should not overlap
 */
export const siteGroups = {
    even: (siteId) => siteId % 2 === 0,
    odd: (siteId) => siteId % 2 !== 0,
};
/**
 * Global instance for initialising and getting experiments' data.
 * TODO: Move it to the DI global container if ready.
 * NOTICE Trouble is that this is used way before client is even initialized
 */
const _storage = LocalStorage.create();
const fieldTest = new FieldTests({
    fieldTestsStorageManager: new StorageManagerFactory(_storage, new StorageVersionManager(_storage)).forFieldTests(),
});
export default {
    init() {
        fieldTest.applyExperiments([menuStickyTabs]);
        // fieldTest.cleanup([
        //   menuStickyTabs,
        //   cartPromotionsView,
        // ] as Experiment<string>[]);
    },
    getVariant(experiment) {
        return fieldTest.getVariant(experiment);
    },
    apply(experiment) {
        fieldTest.applyExperiments([experiment]);
    },
};
